import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Lock, CalendarDays } from "lucide-react";

export default function History() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/foods/history").then(({ data }) => setData(data));
  }, []);

  return (
    <Layout>
      <div className="space-y-6">
        <div className="fade-up">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">Your journey</p>
          <h1 className="font-heading text-3xl font-black mt-1">History</h1>
        </div>

        {data && data.days.length === 0 && (
          <div className="bg-card border border-dashed border-border rounded-2xl p-10 text-center text-muted-foreground" data-testid="history-empty">
            No history yet. Start logging today!
          </div>
        )}

        {data?.days.map((day) => (
          <div key={day.date} className="bg-card border border-border rounded-2xl p-6 fade-up" data-testid={`history-day-${day.date}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <CalendarDays className="w-4 h-4 text-secondary" />
                <p className="font-heading font-bold">{new Date(day.date).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })}</p>
              </div>
              <div className="flex gap-2">
                <span className="text-xs font-bold px-2.5 py-1 rounded-full bg-primary/10 text-primary">{day.total_sugar_grams}g</span>
                <span className="text-xs font-bold px-2.5 py-1 rounded-full bg-muted text-muted-foreground">{day.total_calories} kcal</span>
              </div>
            </div>
            <div className="space-y-2">
              {day.logs.map((log) => (
                <div key={log.id} className="flex items-center justify-between text-sm border-t border-border pt-2 first:border-0 first:pt-0">
                  <span className="capitalize truncate pr-3">{log.description}</span>
                  <span className="text-muted-foreground font-semibold shrink-0">{log.sugar_grams}g</span>
                </div>
              ))}
            </div>
          </div>
        ))}

        {data?.limited && (
          <div className="bg-accent/20 border border-accent rounded-2xl p-6 text-center fade-up" data-testid="history-upgrade-cta">
            <Lock className="w-6 h-6 mx-auto mb-2 text-primary" />
            <p className="font-heading font-bold">Free plan shows only the last 7 days</p>
            <p className="text-sm text-muted-foreground mb-4">Upgrade to Premium for your full history and trends.</p>
            <Button onClick={() => navigate("/pricing")} className="rounded-full font-bold" data-testid="history-upgrade-btn">Unlock full history</Button>
          </div>
        )}
      </div>
    </Layout>
  );
}
